import { useContext } from 'react';

import { ModalContext } from './ModalContext';

export const useModal = () => {
  const { closeModal, currents, openModal, replaceModal } =
    useContext(ModalContext);

  return { openModal, replaceModal, closeModal, currents };
};
